import { render, staticRenderFns } from "./UpdateAdminContent.vue?vue&type=template&id=e1b56854&scoped=true&"
import script from "./UpdateAdminContent.vue?vue&type=script&lang=js&"
export * from "./UpdateAdminContent.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAdminContent.vue?vue&type=style&index=0&id=e1b56854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b56854",
  null
  
)

export default component.exports